import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import MatomoAnalytics from './components/MatomoAnalytics';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Impressum from './pages/Impressum';
import ToS from './pages/ToS';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import SMTPSettings from './pages/SMTPSettings';
import AccountSettings from './pages/AccountSettings';

const Layout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const [matomoConfig, setMatomoConfig] = useState({
    embedCode: '',
    enableAnalytics: false
  });

  // Fetch Matomo configuration
  useEffect(() => {
    const fetchMatomoConfig = async () => {
      try {
        const response = await fetch('/api/matomo/config');
        if (response.ok) {
          const config = await response.json();
          setMatomoConfig({
            embedCode: config.embedCode || '',
            enableAnalytics: config.enableAnalytics || false
          });
        }
      } catch (err) {
        console.error('Failed to fetch Matomo config:', err);
      }
    };

    fetchMatomoConfig();
  }, []);

  return (
    <div className="App">
      {/* Matomo Analytics - only on non-admin routes */}
      {!isAdminRoute && (
        <MatomoAnalytics 
          embedCode={matomoConfig.embedCode}
          enableAnalytics={matomoConfig.enableAnalytics}
        />
      )}
      {!isAdminRoute && <Header />}
      <main>
        {children}
      </main>
      {!isAdminRoute && <Footer />}
    </div>
  );
};

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rolam" element={<About />} />
          <Route path="/galeria" element={<Gallery />} />
          <Route path="/kapcsolat" element={<Contact />} />
          <Route path="/adatvedelem" element={<Privacy />} />
          <Route path="/impresszum" element={<Impressum />} />
          <Route path="/aszf" element={<ToS />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/smtp" element={<SMTPSettings />} />
          <Route path="/admin/account" element={<AccountSettings />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
